export default __webpack_public_path__ + "static/media/kim.73186621.jpg";